// Dependencies
require("webstrap/type");

// Styles
require("./calendrier-1-1.scss");

// JavaScript
var $ = require("jquery");
window.jQuery = $;
require("sticky-kit/dist/sticky-kit.js");

var $cal = $(".calendrier-1-1__container");
if ($cal.length > 0) {
    $cal.stick_in_parent({
        parent: $cal.parent(),
        inner_scrolling: true,
        sticky_class: "",
        bottoming: true,
        offset_top: 0
    });
}



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/calendrier-1/view-1/index.js
// module id = 173
// module chunks = 0